import { render, staticRenderFns } from "./SwitchInputSelect.vue?vue&type=template&id=081bceae&"
import script from "./SwitchInputSelect.vue?vue&type=script&lang=ts&"
export * from "./SwitchInputSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports